module.exports = __webpack_public_path__ + "29068c2101efab6cc97813c8e6b956df.png";